import { transformToProductSelection } from '../../@products/ProductSelection/ProductSelectionTransformers';
import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import { ProductOverviewInterface, ProductOverviewResource } from './ProductOverview';

export const transformToProductOverview = (resource: ProductOverviewResource): ProductOverviewInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    const productSelection = resource.productSelectie
        ? transformToProductSelection(resource.productSelectie)
        : undefined;

    return {
        ...defaultBlock,
        type: BlockType.productOverview,
        title: resource.title || '',
        productSelection,
    };
};
